<template>
  <van-popup class="region" v-model="show" round position="bottom">
    <van-form @submit="handleSubmit">
      <div v-if="pattern === 'add'" class="footer">
        <van-field
          v-model="customerTel"
          label="手机号"
          placeholder="请输入客户手机号"
        />
        <van-button type="info" size="small" native-type="submit"
          >确定</van-button
        >
        <van-button size="small" @click="show = false">取消</van-button>
      </div>
    </van-form>
  </van-popup>
</template>

<script>
import { fillInCustomPhoneNumber } from "@/api/order";
export default {
  name: "Region",
  components: {},
  props: {
    orderId: {
      type: Number,
      require: true
    },
    visible: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({
        orgNum: "",
        orgName: "",
        orgAddress: "",
        lng: undefined,
        lat: undefined,
      }),
    },
    pattern: {
      type: String,
      default: "add",
      validator: (value) => {
        return ["add", "edit"].includes(value);
      },
    },
  },
  data() {
    return {
      customerTel: "",
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  created() {},
  beforeDestroy() {},
  methods: {
    handleSubmit() {
       const { orderId } = this
      console.log(this.moblie);
      if (!/^1[3456789]\d{9}$/.test(this.customerTel)) {
        return this.$toast("手机号格式不正确");
      }
      fillInCustomPhoneNumber({
        orderId: orderId,
        customerTel: this.customerTel,
      }).then((res) => {
        if (res.errcode === 0) {
          this.show = false;
          this.$emit("addMobileSuccess");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.region {
  .van-field {
    overflow: unset;

    /deep/ .van-field__label {
      margin-right: 0;
      width: 5em;
    }

    /deep/ .van-field__body {
      font-size: 12px;
    }
  }

  #map {
    height: 300px;
    margin-top: 10px;
  }

  .footer {
    padding: 10px 0;
    text-align: center;

    .van-button {
      width: 100px;

      &:first-of-type {
        margin-right: 50px;
      }
    }
  }

  /deep/ .amap-ui-poi-picker-sugg-container {
    max-height: 300px;
  }
}
</style>
